// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/transportation/crew/crew.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { EmptyRequest, EmptyResponse } from "../../../common/messages/messages";

export const protobufPackage = "services.transportation.crew";

export interface SubmitAppraisalRequest {
  user: string;
  crewId: string;
  crewChangeId: string;
  appraisal: CrewAppraisal | undefined;
  id: string;
}

export interface AppraisalItem {
  item: string;
  grade?: string | undefined;
  category: string;
  remark?: string | undefined;
}

export interface CrewAppraisal {
  id: string;
  date: string;
  documentId: string;
  masterId: string;
  assessorId: string;
  appraisals: AppraisalItem[];
}

export interface CrewChangeItem {
  plan: string;
  place: string;
  time: number;
  isCancelled: boolean;
}

export interface CrewContract {
  managementOrganisationId: string;
  date: string;
  durationInMonths: number;
  basicSalaryUsd: number;
  guaranteedOvertimeUsd: number;
  leavePayUsd: number;
  leaveSubsistenceUsd: number;
  tankerAllowanceUsd: number;
  contractDocumentId: string;
  extensions: CrewContract[];
}

export interface CrewChange {
  id: string;
  voyageNumber: string;
  vesselName: string;
  vesselImo: string;
  rank: string;
  isCancelled: boolean;
  isDeleted: boolean;
  item: CrewChangeItem[];
  contract?: CrewContract | undefined;
  appraisals: CrewAppraisal[];
}

export interface CrewDocument {
  documentName: string;
  number: string;
  issueDate?: string | undefined;
  expirationDate: string;
  fileId: string;
}

export interface CrewDataHistory {
  docs: CrewDocument[];
  contactInfo: string[];
}

export interface Remark {
  status: string;
  comment: string;
  author?: string | undefined;
  date: string;
  /** services.actions.DatabaseAction action = 6; */
  docId?: string | undefined;
}

export interface Crew {
  id: string;
  firstName: string;
  lastName: string;
  middleName?: string | undefined;
  photoDocumentId?: string | undefined;
  birthDate: string;
  passportDetails: CrewDocument | undefined;
  seamanDetails: CrewDocument | undefined;
  nationality: string;
  contactNumber?: string | undefined;
  cvDocumentId?: string | undefined;
  crewChanges: CrewChange[];
  oldDetails: CrewDataHistory | undefined;
  ssoUsername?: string | undefined;
  credentials: CrewDocument[];
  remarks: Remark[];
}

export interface GetCrewByIdRequest {
  id: string;
}

export interface UpdateCrewRequest {
  data: Crew | undefined;
  expectedVersion: number;
}

export interface CrewResponse {
  data: Crew | undefined;
  version: number;
}

export interface GetCrewResponse {
  crews: CrewResponse[];
}

export interface OnboardCrew {
  crew: Crew | undefined;
  onboardCrewChange: CrewChange | undefined;
  version: number;
}

export interface GetOnboardCrewResponse {
  crews: OnboardCrew[];
}

export interface GetOnboardCrewByVesselImoRequest {
  vesselImo: string;
}

export interface AssignedVesselImoResponse {
  vesselImo: string;
}

export interface GetCrewsByVesselImoRequest {
  vesselImo: string;
}

export interface UpdateCrewChangePlanRequest {
  crewId: string;
  crewChangeId: string;
  incomingFlight: CrewChangeItem | undefined;
  onBoard: CrewChangeItem | undefined;
  offBoard: CrewChangeItem | undefined;
  outgoingFlight: CrewChangeItem | undefined;
  expectedVersion: number;
}

export interface UpdateCrewChangeContractRequest {
  crewId: string;
  crewChangeId: string;
  contract: CrewContract | undefined;
  expectedVersion: number;
}

export interface UpdateCrewChangePlanResponse {
}

export interface UpdateCrewChangeContractResponse {
}

export interface AddCrewSsoUsernameRequest {
  crewId: string;
  expectedVersion: number;
}

export interface AddCrewSsoUsernameResponse {
  assignedSsoUsername: string;
  temporarySsoPassword: string;
}

export interface AddNewCrewChangeRequest {
  crewId: string;
  rank: string;
  vesselImo: string;
  vesselName: string;
  voyageNumber: string;
  expectedVersion: number;
}

export interface AddNewCrewChangeResponse {
  crewId: string;
  crewChangeId: string;
}

function createBaseSubmitAppraisalRequest(): SubmitAppraisalRequest {
  return { user: "", crewId: "", crewChangeId: "", appraisal: undefined, id: "" };
}

export const SubmitAppraisalRequest: MessageFns<SubmitAppraisalRequest> = {
  encode(message: SubmitAppraisalRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user !== "") {
      writer.uint32(10).string(message.user);
    }
    if (message.crewId !== "") {
      writer.uint32(18).string(message.crewId);
    }
    if (message.crewChangeId !== "") {
      writer.uint32(26).string(message.crewChangeId);
    }
    if (message.appraisal !== undefined) {
      CrewAppraisal.encode(message.appraisal, writer.uint32(34).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(42).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitAppraisalRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitAppraisalRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.crewId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.crewChangeId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.appraisal = CrewAppraisal.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitAppraisalRequest {
    return {
      user: isSet(object.user) ? globalThis.String(object.user) : "",
      crewId: isSet(object.crewId)
        ? globalThis.String(object.crewId)
        : isSet(object.crew_id)
        ? globalThis.String(object.crew_id)
        : "",
      crewChangeId: isSet(object.crewChangeId)
        ? globalThis.String(object.crewChangeId)
        : isSet(object.crew_change_id)
        ? globalThis.String(object.crew_change_id)
        : "",
      appraisal: isSet(object.appraisal) ? CrewAppraisal.fromJSON(object.appraisal) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: SubmitAppraisalRequest): unknown {
    const obj: any = {};
    if (message.user !== "") {
      obj.user = message.user;
    }
    if (message.crewId !== "") {
      obj.crewId = message.crewId;
    }
    if (message.crewChangeId !== "") {
      obj.crewChangeId = message.crewChangeId;
    }
    if (message.appraisal !== undefined) {
      obj.appraisal = CrewAppraisal.toJSON(message.appraisal);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitAppraisalRequest>, I>>(base?: I): SubmitAppraisalRequest {
    return SubmitAppraisalRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitAppraisalRequest>, I>>(object: I): SubmitAppraisalRequest {
    const message = createBaseSubmitAppraisalRequest();
    message.user = object.user ?? "";
    message.crewId = object.crewId ?? "";
    message.crewChangeId = object.crewChangeId ?? "";
    message.appraisal = (object.appraisal !== undefined && object.appraisal !== null)
      ? CrewAppraisal.fromPartial(object.appraisal)
      : undefined;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseAppraisalItem(): AppraisalItem {
  return { item: "", grade: undefined, category: "", remark: undefined };
}

export const AppraisalItem: MessageFns<AppraisalItem> = {
  encode(message: AppraisalItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.item !== "") {
      writer.uint32(10).string(message.item);
    }
    if (message.grade !== undefined) {
      writer.uint32(18).string(message.grade);
    }
    if (message.category !== "") {
      writer.uint32(26).string(message.category);
    }
    if (message.remark !== undefined) {
      writer.uint32(34).string(message.remark);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppraisalItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppraisalItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.item = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.grade = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.remark = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppraisalItem {
    return {
      item: isSet(object.item) ? globalThis.String(object.item) : "",
      grade: isSet(object.grade) ? globalThis.String(object.grade) : undefined,
      category: isSet(object.category) ? globalThis.String(object.category) : "",
      remark: isSet(object.remark) ? globalThis.String(object.remark) : undefined,
    };
  },

  toJSON(message: AppraisalItem): unknown {
    const obj: any = {};
    if (message.item !== "") {
      obj.item = message.item;
    }
    if (message.grade !== undefined) {
      obj.grade = message.grade;
    }
    if (message.category !== "") {
      obj.category = message.category;
    }
    if (message.remark !== undefined) {
      obj.remark = message.remark;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AppraisalItem>, I>>(base?: I): AppraisalItem {
    return AppraisalItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AppraisalItem>, I>>(object: I): AppraisalItem {
    const message = createBaseAppraisalItem();
    message.item = object.item ?? "";
    message.grade = object.grade ?? undefined;
    message.category = object.category ?? "";
    message.remark = object.remark ?? undefined;
    return message;
  },
};

function createBaseCrewAppraisal(): CrewAppraisal {
  return { id: "", date: "", documentId: "", masterId: "", assessorId: "", appraisals: [] };
}

export const CrewAppraisal: MessageFns<CrewAppraisal> = {
  encode(message: CrewAppraisal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.date !== "") {
      writer.uint32(18).string(message.date);
    }
    if (message.documentId !== "") {
      writer.uint32(26).string(message.documentId);
    }
    if (message.masterId !== "") {
      writer.uint32(34).string(message.masterId);
    }
    if (message.assessorId !== "") {
      writer.uint32(42).string(message.assessorId);
    }
    for (const v of message.appraisals) {
      AppraisalItem.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrewAppraisal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrewAppraisal();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.masterId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.assessorId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.appraisals.push(AppraisalItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CrewAppraisal {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      masterId: isSet(object.masterId)
        ? globalThis.String(object.masterId)
        : isSet(object.master_id)
        ? globalThis.String(object.master_id)
        : "",
      assessorId: isSet(object.assessorId)
        ? globalThis.String(object.assessorId)
        : isSet(object.assessor_id)
        ? globalThis.String(object.assessor_id)
        : "",
      appraisals: globalThis.Array.isArray(object?.appraisals)
        ? object.appraisals.map((e: any) => AppraisalItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CrewAppraisal): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.masterId !== "") {
      obj.masterId = message.masterId;
    }
    if (message.assessorId !== "") {
      obj.assessorId = message.assessorId;
    }
    if (message.appraisals?.length) {
      obj.appraisals = message.appraisals.map((e) => AppraisalItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CrewAppraisal>, I>>(base?: I): CrewAppraisal {
    return CrewAppraisal.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CrewAppraisal>, I>>(object: I): CrewAppraisal {
    const message = createBaseCrewAppraisal();
    message.id = object.id ?? "";
    message.date = object.date ?? "";
    message.documentId = object.documentId ?? "";
    message.masterId = object.masterId ?? "";
    message.assessorId = object.assessorId ?? "";
    message.appraisals = object.appraisals?.map((e) => AppraisalItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCrewChangeItem(): CrewChangeItem {
  return { plan: "", place: "", time: 0, isCancelled: false };
}

export const CrewChangeItem: MessageFns<CrewChangeItem> = {
  encode(message: CrewChangeItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.plan !== "") {
      writer.uint32(10).string(message.plan);
    }
    if (message.place !== "") {
      writer.uint32(18).string(message.place);
    }
    if (message.time !== 0) {
      writer.uint32(24).int64(message.time);
    }
    if (message.isCancelled !== false) {
      writer.uint32(32).bool(message.isCancelled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrewChangeItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrewChangeItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.plan = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.place = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.time = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isCancelled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CrewChangeItem {
    return {
      plan: isSet(object.plan) ? globalThis.String(object.plan) : "",
      place: isSet(object.place) ? globalThis.String(object.place) : "",
      time: isSet(object.time) ? globalThis.Number(object.time) : 0,
      isCancelled: isSet(object.isCancelled)
        ? globalThis.Boolean(object.isCancelled)
        : isSet(object.is_cancelled)
        ? globalThis.Boolean(object.is_cancelled)
        : false,
    };
  },

  toJSON(message: CrewChangeItem): unknown {
    const obj: any = {};
    if (message.plan !== "") {
      obj.plan = message.plan;
    }
    if (message.place !== "") {
      obj.place = message.place;
    }
    if (message.time !== 0) {
      obj.time = Math.round(message.time);
    }
    if (message.isCancelled !== false) {
      obj.isCancelled = message.isCancelled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CrewChangeItem>, I>>(base?: I): CrewChangeItem {
    return CrewChangeItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CrewChangeItem>, I>>(object: I): CrewChangeItem {
    const message = createBaseCrewChangeItem();
    message.plan = object.plan ?? "";
    message.place = object.place ?? "";
    message.time = object.time ?? 0;
    message.isCancelled = object.isCancelled ?? false;
    return message;
  },
};

function createBaseCrewContract(): CrewContract {
  return {
    managementOrganisationId: "",
    date: "",
    durationInMonths: 0,
    basicSalaryUsd: 0,
    guaranteedOvertimeUsd: 0,
    leavePayUsd: 0,
    leaveSubsistenceUsd: 0,
    tankerAllowanceUsd: 0,
    contractDocumentId: "",
    extensions: [],
  };
}

export const CrewContract: MessageFns<CrewContract> = {
  encode(message: CrewContract, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.managementOrganisationId !== "") {
      writer.uint32(10).string(message.managementOrganisationId);
    }
    if (message.date !== "") {
      writer.uint32(18).string(message.date);
    }
    if (message.durationInMonths !== 0) {
      writer.uint32(24).int32(message.durationInMonths);
    }
    if (message.basicSalaryUsd !== 0) {
      writer.uint32(32).int32(message.basicSalaryUsd);
    }
    if (message.guaranteedOvertimeUsd !== 0) {
      writer.uint32(40).int32(message.guaranteedOvertimeUsd);
    }
    if (message.leavePayUsd !== 0) {
      writer.uint32(48).int32(message.leavePayUsd);
    }
    if (message.leaveSubsistenceUsd !== 0) {
      writer.uint32(56).int32(message.leaveSubsistenceUsd);
    }
    if (message.tankerAllowanceUsd !== 0) {
      writer.uint32(64).int32(message.tankerAllowanceUsd);
    }
    if (message.contractDocumentId !== "") {
      writer.uint32(74).string(message.contractDocumentId);
    }
    for (const v of message.extensions) {
      CrewContract.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrewContract {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrewContract();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.managementOrganisationId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.durationInMonths = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.basicSalaryUsd = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.guaranteedOvertimeUsd = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.leavePayUsd = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.leaveSubsistenceUsd = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.tankerAllowanceUsd = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.contractDocumentId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.extensions.push(CrewContract.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CrewContract {
    return {
      managementOrganisationId: isSet(object.managementOrganisationId)
        ? globalThis.String(object.managementOrganisationId)
        : isSet(object.management_organisation_id)
        ? globalThis.String(object.management_organisation_id)
        : "",
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      durationInMonths: isSet(object.durationInMonths)
        ? globalThis.Number(object.durationInMonths)
        : isSet(object.duration_in_months)
        ? globalThis.Number(object.duration_in_months)
        : 0,
      basicSalaryUsd: isSet(object.basicSalaryUsd)
        ? globalThis.Number(object.basicSalaryUsd)
        : isSet(object.basic_salary_usd)
        ? globalThis.Number(object.basic_salary_usd)
        : 0,
      guaranteedOvertimeUsd: isSet(object.guaranteedOvertimeUsd)
        ? globalThis.Number(object.guaranteedOvertimeUsd)
        : isSet(object.guaranteed_overtime_usd)
        ? globalThis.Number(object.guaranteed_overtime_usd)
        : 0,
      leavePayUsd: isSet(object.leavePayUsd)
        ? globalThis.Number(object.leavePayUsd)
        : isSet(object.leave_pay_usd)
        ? globalThis.Number(object.leave_pay_usd)
        : 0,
      leaveSubsistenceUsd: isSet(object.leaveSubsistenceUsd)
        ? globalThis.Number(object.leaveSubsistenceUsd)
        : isSet(object.leave_subsistence_usd)
        ? globalThis.Number(object.leave_subsistence_usd)
        : 0,
      tankerAllowanceUsd: isSet(object.tankerAllowanceUsd)
        ? globalThis.Number(object.tankerAllowanceUsd)
        : isSet(object.tanker_allowance_usd)
        ? globalThis.Number(object.tanker_allowance_usd)
        : 0,
      contractDocumentId: isSet(object.contractDocumentId)
        ? globalThis.String(object.contractDocumentId)
        : isSet(object.contract_document_id)
        ? globalThis.String(object.contract_document_id)
        : "",
      extensions: globalThis.Array.isArray(object?.extensions)
        ? object.extensions.map((e: any) => CrewContract.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CrewContract): unknown {
    const obj: any = {};
    if (message.managementOrganisationId !== "") {
      obj.managementOrganisationId = message.managementOrganisationId;
    }
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.durationInMonths !== 0) {
      obj.durationInMonths = Math.round(message.durationInMonths);
    }
    if (message.basicSalaryUsd !== 0) {
      obj.basicSalaryUsd = Math.round(message.basicSalaryUsd);
    }
    if (message.guaranteedOvertimeUsd !== 0) {
      obj.guaranteedOvertimeUsd = Math.round(message.guaranteedOvertimeUsd);
    }
    if (message.leavePayUsd !== 0) {
      obj.leavePayUsd = Math.round(message.leavePayUsd);
    }
    if (message.leaveSubsistenceUsd !== 0) {
      obj.leaveSubsistenceUsd = Math.round(message.leaveSubsistenceUsd);
    }
    if (message.tankerAllowanceUsd !== 0) {
      obj.tankerAllowanceUsd = Math.round(message.tankerAllowanceUsd);
    }
    if (message.contractDocumentId !== "") {
      obj.contractDocumentId = message.contractDocumentId;
    }
    if (message.extensions?.length) {
      obj.extensions = message.extensions.map((e) => CrewContract.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CrewContract>, I>>(base?: I): CrewContract {
    return CrewContract.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CrewContract>, I>>(object: I): CrewContract {
    const message = createBaseCrewContract();
    message.managementOrganisationId = object.managementOrganisationId ?? "";
    message.date = object.date ?? "";
    message.durationInMonths = object.durationInMonths ?? 0;
    message.basicSalaryUsd = object.basicSalaryUsd ?? 0;
    message.guaranteedOvertimeUsd = object.guaranteedOvertimeUsd ?? 0;
    message.leavePayUsd = object.leavePayUsd ?? 0;
    message.leaveSubsistenceUsd = object.leaveSubsistenceUsd ?? 0;
    message.tankerAllowanceUsd = object.tankerAllowanceUsd ?? 0;
    message.contractDocumentId = object.contractDocumentId ?? "";
    message.extensions = object.extensions?.map((e) => CrewContract.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCrewChange(): CrewChange {
  return {
    id: "",
    voyageNumber: "",
    vesselName: "",
    vesselImo: "",
    rank: "",
    isCancelled: false,
    isDeleted: false,
    item: [],
    contract: undefined,
    appraisals: [],
  };
}

export const CrewChange: MessageFns<CrewChange> = {
  encode(message: CrewChange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.voyageNumber !== "") {
      writer.uint32(18).string(message.voyageNumber);
    }
    if (message.vesselName !== "") {
      writer.uint32(26).string(message.vesselName);
    }
    if (message.vesselImo !== "") {
      writer.uint32(34).string(message.vesselImo);
    }
    if (message.rank !== "") {
      writer.uint32(42).string(message.rank);
    }
    if (message.isCancelled !== false) {
      writer.uint32(48).bool(message.isCancelled);
    }
    if (message.isDeleted !== false) {
      writer.uint32(56).bool(message.isDeleted);
    }
    for (const v of message.item) {
      CrewChangeItem.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.contract !== undefined) {
      CrewContract.encode(message.contract, writer.uint32(74).fork()).join();
    }
    for (const v of message.appraisals) {
      CrewAppraisal.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrewChange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrewChange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.voyageNumber = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.rank = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isCancelled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isDeleted = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.item.push(CrewChangeItem.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.contract = CrewContract.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.appraisals.push(CrewAppraisal.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CrewChange {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      voyageNumber: isSet(object.voyageNumber)
        ? globalThis.String(object.voyageNumber)
        : isSet(object.voyage_number)
        ? globalThis.String(object.voyage_number)
        : "",
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : "",
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      rank: isSet(object.rank) ? globalThis.String(object.rank) : "",
      isCancelled: isSet(object.isCancelled)
        ? globalThis.Boolean(object.isCancelled)
        : isSet(object.is_cancelled)
        ? globalThis.Boolean(object.is_cancelled)
        : false,
      isDeleted: isSet(object.isDeleted)
        ? globalThis.Boolean(object.isDeleted)
        : isSet(object.is_deleted)
        ? globalThis.Boolean(object.is_deleted)
        : false,
      item: globalThis.Array.isArray(object?.item)
        ? object.item.map((e: any) => CrewChangeItem.fromJSON(e))
        : [],
      contract: isSet(object.contract) ? CrewContract.fromJSON(object.contract) : undefined,
      appraisals: globalThis.Array.isArray(object?.appraisals)
        ? object.appraisals.map((e: any) => CrewAppraisal.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CrewChange): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.voyageNumber !== "") {
      obj.voyageNumber = message.voyageNumber;
    }
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.rank !== "") {
      obj.rank = message.rank;
    }
    if (message.isCancelled !== false) {
      obj.isCancelled = message.isCancelled;
    }
    if (message.isDeleted !== false) {
      obj.isDeleted = message.isDeleted;
    }
    if (message.item?.length) {
      obj.item = message.item.map((e) => CrewChangeItem.toJSON(e));
    }
    if (message.contract !== undefined) {
      obj.contract = CrewContract.toJSON(message.contract);
    }
    if (message.appraisals?.length) {
      obj.appraisals = message.appraisals.map((e) => CrewAppraisal.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CrewChange>, I>>(base?: I): CrewChange {
    return CrewChange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CrewChange>, I>>(object: I): CrewChange {
    const message = createBaseCrewChange();
    message.id = object.id ?? "";
    message.voyageNumber = object.voyageNumber ?? "";
    message.vesselName = object.vesselName ?? "";
    message.vesselImo = object.vesselImo ?? "";
    message.rank = object.rank ?? "";
    message.isCancelled = object.isCancelled ?? false;
    message.isDeleted = object.isDeleted ?? false;
    message.item = object.item?.map((e) => CrewChangeItem.fromPartial(e)) || [];
    message.contract = (object.contract !== undefined && object.contract !== null)
      ? CrewContract.fromPartial(object.contract)
      : undefined;
    message.appraisals = object.appraisals?.map((e) => CrewAppraisal.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCrewDocument(): CrewDocument {
  return { documentName: "", number: "", issueDate: undefined, expirationDate: "", fileId: "" };
}

export const CrewDocument: MessageFns<CrewDocument> = {
  encode(message: CrewDocument, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentName !== "") {
      writer.uint32(10).string(message.documentName);
    }
    if (message.number !== "") {
      writer.uint32(18).string(message.number);
    }
    if (message.issueDate !== undefined) {
      writer.uint32(26).string(message.issueDate);
    }
    if (message.expirationDate !== "") {
      writer.uint32(34).string(message.expirationDate);
    }
    if (message.fileId !== "") {
      writer.uint32(42).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrewDocument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrewDocument();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.number = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.issueDate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.expirationDate = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CrewDocument {
    return {
      documentName: isSet(object.documentName)
        ? globalThis.String(object.documentName)
        : isSet(object.document_name)
        ? globalThis.String(object.document_name)
        : "",
      number: isSet(object.number) ? globalThis.String(object.number) : "",
      issueDate: isSet(object.issueDate)
        ? globalThis.String(object.issueDate)
        : isSet(object.issue_date)
        ? globalThis.String(object.issue_date)
        : undefined,
      expirationDate: isSet(object.expirationDate)
        ? globalThis.String(object.expirationDate)
        : isSet(object.expiration_date)
        ? globalThis.String(object.expiration_date)
        : "",
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
    };
  },

  toJSON(message: CrewDocument): unknown {
    const obj: any = {};
    if (message.documentName !== "") {
      obj.documentName = message.documentName;
    }
    if (message.number !== "") {
      obj.number = message.number;
    }
    if (message.issueDate !== undefined) {
      obj.issueDate = message.issueDate;
    }
    if (message.expirationDate !== "") {
      obj.expirationDate = message.expirationDate;
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CrewDocument>, I>>(base?: I): CrewDocument {
    return CrewDocument.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CrewDocument>, I>>(object: I): CrewDocument {
    const message = createBaseCrewDocument();
    message.documentName = object.documentName ?? "";
    message.number = object.number ?? "";
    message.issueDate = object.issueDate ?? undefined;
    message.expirationDate = object.expirationDate ?? "";
    message.fileId = object.fileId ?? "";
    return message;
  },
};

function createBaseCrewDataHistory(): CrewDataHistory {
  return { docs: [], contactInfo: [] };
}

export const CrewDataHistory: MessageFns<CrewDataHistory> = {
  encode(message: CrewDataHistory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.docs) {
      CrewDocument.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.contactInfo) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrewDataHistory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrewDataHistory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docs.push(CrewDocument.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.contactInfo.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CrewDataHistory {
    return {
      docs: globalThis.Array.isArray(object?.docs) ? object.docs.map((e: any) => CrewDocument.fromJSON(e)) : [],
      contactInfo: globalThis.Array.isArray(object?.contactInfo)
        ? object.contactInfo.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.contact_info)
        ? object.contact_info.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: CrewDataHistory): unknown {
    const obj: any = {};
    if (message.docs?.length) {
      obj.docs = message.docs.map((e) => CrewDocument.toJSON(e));
    }
    if (message.contactInfo?.length) {
      obj.contactInfo = message.contactInfo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CrewDataHistory>, I>>(base?: I): CrewDataHistory {
    return CrewDataHistory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CrewDataHistory>, I>>(object: I): CrewDataHistory {
    const message = createBaseCrewDataHistory();
    message.docs = object.docs?.map((e) => CrewDocument.fromPartial(e)) || [];
    message.contactInfo = object.contactInfo?.map((e) => e) || [];
    return message;
  },
};

function createBaseRemark(): Remark {
  return { status: "", comment: "", author: undefined, date: "", docId: undefined };
}

export const Remark: MessageFns<Remark> = {
  encode(message: Remark, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.comment !== "") {
      writer.uint32(18).string(message.comment);
    }
    if (message.author !== undefined) {
      writer.uint32(26).string(message.author);
    }
    if (message.date !== "") {
      writer.uint32(34).string(message.date);
    }
    if (message.docId !== undefined) {
      writer.uint32(42).string(message.docId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Remark {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemark();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.author = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.docId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Remark {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      comment: isSet(object.comment) ? globalThis.String(object.comment) : "",
      author: isSet(object.author) ? globalThis.String(object.author) : undefined,
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      docId: isSet(object.docId) ? globalThis.String(object.docId) : undefined,
    };
  },

  toJSON(message: Remark): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    if (message.author !== undefined) {
      obj.author = message.author;
    }
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.docId !== undefined) {
      obj.docId = message.docId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Remark>, I>>(base?: I): Remark {
    return Remark.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Remark>, I>>(object: I): Remark {
    const message = createBaseRemark();
    message.status = object.status ?? "";
    message.comment = object.comment ?? "";
    message.author = object.author ?? undefined;
    message.date = object.date ?? "";
    message.docId = object.docId ?? undefined;
    return message;
  },
};

function createBaseCrew(): Crew {
  return {
    id: "",
    firstName: "",
    lastName: "",
    middleName: undefined,
    photoDocumentId: undefined,
    birthDate: "",
    passportDetails: undefined,
    seamanDetails: undefined,
    nationality: "",
    contactNumber: undefined,
    cvDocumentId: undefined,
    crewChanges: [],
    oldDetails: undefined,
    ssoUsername: undefined,
    credentials: [],
    remarks: [],
  };
}

export const Crew: MessageFns<Crew> = {
  encode(message: Crew, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.firstName !== "") {
      writer.uint32(18).string(message.firstName);
    }
    if (message.lastName !== "") {
      writer.uint32(26).string(message.lastName);
    }
    if (message.middleName !== undefined) {
      writer.uint32(34).string(message.middleName);
    }
    if (message.photoDocumentId !== undefined) {
      writer.uint32(42).string(message.photoDocumentId);
    }
    if (message.birthDate !== "") {
      writer.uint32(50).string(message.birthDate);
    }
    if (message.passportDetails !== undefined) {
      CrewDocument.encode(message.passportDetails, writer.uint32(58).fork()).join();
    }
    if (message.seamanDetails !== undefined) {
      CrewDocument.encode(message.seamanDetails, writer.uint32(66).fork()).join();
    }
    if (message.nationality !== "") {
      writer.uint32(74).string(message.nationality);
    }
    if (message.contactNumber !== undefined) {
      writer.uint32(82).string(message.contactNumber);
    }
    if (message.cvDocumentId !== undefined) {
      writer.uint32(90).string(message.cvDocumentId);
    }
    for (const v of message.crewChanges) {
      CrewChange.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.oldDetails !== undefined) {
      CrewDataHistory.encode(message.oldDetails, writer.uint32(114).fork()).join();
    }
    if (message.ssoUsername !== undefined) {
      writer.uint32(122).string(message.ssoUsername);
    }
    for (const v of message.credentials) {
      CrewDocument.encode(v!, writer.uint32(130).fork()).join();
    }
    for (const v of message.remarks) {
      Remark.encode(v!, writer.uint32(138).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Crew {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrew();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.firstName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.middleName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.photoDocumentId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.birthDate = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.passportDetails = CrewDocument.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.seamanDetails = CrewDocument.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.nationality = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.contactNumber = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.cvDocumentId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.crewChanges.push(CrewChange.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.oldDetails = CrewDataHistory.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.ssoUsername = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.credentials.push(CrewDocument.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.remarks.push(Remark.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Crew {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      firstName: isSet(object.firstName)
        ? globalThis.String(object.firstName)
        : isSet(object.first_name)
        ? globalThis.String(object.first_name)
        : "",
      lastName: isSet(object.lastName)
        ? globalThis.String(object.lastName)
        : isSet(object.last_name)
        ? globalThis.String(object.last_name)
        : "",
      middleName: isSet(object.middleName)
        ? globalThis.String(object.middleName)
        : isSet(object.middle_name)
        ? globalThis.String(object.middle_name)
        : undefined,
      photoDocumentId: isSet(object.photoDocumentId)
        ? globalThis.String(object.photoDocumentId)
        : isSet(object.photo_document_id)
        ? globalThis.String(object.photo_document_id)
        : undefined,
      birthDate: isSet(object.birthDate) ? globalThis.String(object.birthDate) : "",
      passportDetails: isSet(object.passportDetails)
        ? CrewDocument.fromJSON(object.passportDetails)
        : isSet(object.passport_details)
        ? CrewDocument.fromJSON(object.passport_details)
        : undefined,
      seamanDetails: isSet(object.seamanDetails)
        ? CrewDocument.fromJSON(object.seamanDetails)
        : isSet(object.seaman_details)
        ? CrewDocument.fromJSON(object.seaman_details)
        : undefined,
      nationality: isSet(object.nationality) ? globalThis.String(object.nationality) : "",
      contactNumber: isSet(object.contactNumber)
        ? globalThis.String(object.contactNumber)
        : isSet(object.contact_number)
        ? globalThis.String(object.contact_number)
        : undefined,
      cvDocumentId: isSet(object.cvDocumentId)
        ? globalThis.String(object.cvDocumentId)
        : isSet(object.cv_document_id)
        ? globalThis.String(object.cv_document_id)
        : undefined,
      crewChanges: globalThis.Array.isArray(object?.crewChanges)
        ? object.crewChanges.map((e: any) => CrewChange.fromJSON(e))
        : globalThis.Array.isArray(object?.crew_changes)
        ? object.crew_changes.map((e: any) => CrewChange.fromJSON(e))
        : [],
      oldDetails: isSet(object.oldDetails)
        ? CrewDataHistory.fromJSON(object.oldDetails)
        : isSet(object.old_details)
        ? CrewDataHistory.fromJSON(object.old_details)
        : undefined,
      ssoUsername: isSet(object.ssoUsername)
        ? globalThis.String(object.ssoUsername)
        : isSet(object.sso_username)
        ? globalThis.String(object.sso_username)
        : undefined,
      credentials: globalThis.Array.isArray(object?.credentials)
        ? object.credentials.map((e: any) => CrewDocument.fromJSON(e))
        : [],
      remarks: globalThis.Array.isArray(object?.remarks)
        ? object.remarks.map((e: any) => Remark.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Crew): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.firstName !== "") {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== "") {
      obj.lastName = message.lastName;
    }
    if (message.middleName !== undefined) {
      obj.middleName = message.middleName;
    }
    if (message.photoDocumentId !== undefined) {
      obj.photoDocumentId = message.photoDocumentId;
    }
    if (message.birthDate !== "") {
      obj.birthDate = message.birthDate;
    }
    if (message.passportDetails !== undefined) {
      obj.passportDetails = CrewDocument.toJSON(message.passportDetails);
    }
    if (message.seamanDetails !== undefined) {
      obj.seamanDetails = CrewDocument.toJSON(message.seamanDetails);
    }
    if (message.nationality !== "") {
      obj.nationality = message.nationality;
    }
    if (message.contactNumber !== undefined) {
      obj.contactNumber = message.contactNumber;
    }
    if (message.cvDocumentId !== undefined) {
      obj.cvDocumentId = message.cvDocumentId;
    }
    if (message.crewChanges?.length) {
      obj.crewChanges = message.crewChanges.map((e) => CrewChange.toJSON(e));
    }
    if (message.oldDetails !== undefined) {
      obj.oldDetails = CrewDataHistory.toJSON(message.oldDetails);
    }
    if (message.ssoUsername !== undefined) {
      obj.ssoUsername = message.ssoUsername;
    }
    if (message.credentials?.length) {
      obj.credentials = message.credentials.map((e) => CrewDocument.toJSON(e));
    }
    if (message.remarks?.length) {
      obj.remarks = message.remarks.map((e) => Remark.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Crew>, I>>(base?: I): Crew {
    return Crew.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Crew>, I>>(object: I): Crew {
    const message = createBaseCrew();
    message.id = object.id ?? "";
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.middleName = object.middleName ?? undefined;
    message.photoDocumentId = object.photoDocumentId ?? undefined;
    message.birthDate = object.birthDate ?? "";
    message.passportDetails = (object.passportDetails !== undefined && object.passportDetails !== null)
      ? CrewDocument.fromPartial(object.passportDetails)
      : undefined;
    message.seamanDetails = (object.seamanDetails !== undefined && object.seamanDetails !== null)
      ? CrewDocument.fromPartial(object.seamanDetails)
      : undefined;
    message.nationality = object.nationality ?? "";
    message.contactNumber = object.contactNumber ?? undefined;
    message.cvDocumentId = object.cvDocumentId ?? undefined;
    message.crewChanges = object.crewChanges?.map((e) => CrewChange.fromPartial(e)) || [];
    message.oldDetails = (object.oldDetails !== undefined && object.oldDetails !== null)
      ? CrewDataHistory.fromPartial(object.oldDetails)
      : undefined;
    message.ssoUsername = object.ssoUsername ?? undefined;
    message.credentials = object.credentials?.map((e) => CrewDocument.fromPartial(e)) || [];
    message.remarks = object.remarks?.map((e) => Remark.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCrewByIdRequest(): GetCrewByIdRequest {
  return { id: "" };
}

export const GetCrewByIdRequest: MessageFns<GetCrewByIdRequest> = {
  encode(message: GetCrewByIdRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCrewByIdRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCrewByIdRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCrewByIdRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: GetCrewByIdRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCrewByIdRequest>, I>>(base?: I): GetCrewByIdRequest {
    return GetCrewByIdRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCrewByIdRequest>, I>>(object: I): GetCrewByIdRequest {
    const message = createBaseGetCrewByIdRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseUpdateCrewRequest(): UpdateCrewRequest {
  return { data: undefined, expectedVersion: 0 };
}

export const UpdateCrewRequest: MessageFns<UpdateCrewRequest> = {
  encode(message: UpdateCrewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      Crew.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(16).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCrewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCrewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = Crew.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCrewRequest {
    return {
      data: isSet(object.data) ? Crew.fromJSON(object.data) : undefined,
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: UpdateCrewRequest): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = Crew.toJSON(message.data);
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateCrewRequest>, I>>(base?: I): UpdateCrewRequest {
    return UpdateCrewRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateCrewRequest>, I>>(object: I): UpdateCrewRequest {
    const message = createBaseUpdateCrewRequest();
    message.data = (object.data !== undefined && object.data !== null) ? Crew.fromPartial(object.data) : undefined;
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

function createBaseCrewResponse(): CrewResponse {
  return { data: undefined, version: 0 };
}

export const CrewResponse: MessageFns<CrewResponse> = {
  encode(message: CrewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      Crew.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(16).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCrewResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = Crew.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CrewResponse {
    return {
      data: isSet(object.data) ? Crew.fromJSON(object.data) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: CrewResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = Crew.toJSON(message.data);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CrewResponse>, I>>(base?: I): CrewResponse {
    return CrewResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CrewResponse>, I>>(object: I): CrewResponse {
    const message = createBaseCrewResponse();
    message.data = (object.data !== undefined && object.data !== null) ? Crew.fromPartial(object.data) : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseGetCrewResponse(): GetCrewResponse {
  return { crews: [] };
}

export const GetCrewResponse: MessageFns<GetCrewResponse> = {
  encode(message: GetCrewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.crews) {
      CrewResponse.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCrewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCrewResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crews.push(CrewResponse.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCrewResponse {
    return {
      crews: globalThis.Array.isArray(object?.crews) ? object.crews.map((e: any) => CrewResponse.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetCrewResponse): unknown {
    const obj: any = {};
    if (message.crews?.length) {
      obj.crews = message.crews.map((e) => CrewResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCrewResponse>, I>>(base?: I): GetCrewResponse {
    return GetCrewResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCrewResponse>, I>>(object: I): GetCrewResponse {
    const message = createBaseGetCrewResponse();
    message.crews = object.crews?.map((e) => CrewResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOnboardCrew(): OnboardCrew {
  return { crew: undefined, onboardCrewChange: undefined, version: 0 };
}

export const OnboardCrew: MessageFns<OnboardCrew> = {
  encode(message: OnboardCrew, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.crew !== undefined) {
      Crew.encode(message.crew, writer.uint32(10).fork()).join();
    }
    if (message.onboardCrewChange !== undefined) {
      CrewChange.encode(message.onboardCrewChange, writer.uint32(18).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(24).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardCrew {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardCrew();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crew = Crew.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.onboardCrewChange = CrewChange.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardCrew {
    return {
      crew: isSet(object.crew) ? Crew.fromJSON(object.crew) : undefined,
      onboardCrewChange: isSet(object.onboardCrewChange)
        ? CrewChange.fromJSON(object.onboardCrewChange)
        : isSet(object.onboard_crew_change)
        ? CrewChange.fromJSON(object.onboard_crew_change)
        : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: OnboardCrew): unknown {
    const obj: any = {};
    if (message.crew !== undefined) {
      obj.crew = Crew.toJSON(message.crew);
    }
    if (message.onboardCrewChange !== undefined) {
      obj.onboardCrewChange = CrewChange.toJSON(message.onboardCrewChange);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnboardCrew>, I>>(base?: I): OnboardCrew {
    return OnboardCrew.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnboardCrew>, I>>(object: I): OnboardCrew {
    const message = createBaseOnboardCrew();
    message.crew = (object.crew !== undefined && object.crew !== null) ? Crew.fromPartial(object.crew) : undefined;
    message.onboardCrewChange = (object.onboardCrewChange !== undefined && object.onboardCrewChange !== null)
      ? CrewChange.fromPartial(object.onboardCrewChange)
      : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseGetOnboardCrewResponse(): GetOnboardCrewResponse {
  return { crews: [] };
}

export const GetOnboardCrewResponse: MessageFns<GetOnboardCrewResponse> = {
  encode(message: GetOnboardCrewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.crews) {
      OnboardCrew.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOnboardCrewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOnboardCrewResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crews.push(OnboardCrew.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOnboardCrewResponse {
    return {
      crews: globalThis.Array.isArray(object?.crews) ? object.crews.map((e: any) => OnboardCrew.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetOnboardCrewResponse): unknown {
    const obj: any = {};
    if (message.crews?.length) {
      obj.crews = message.crews.map((e) => OnboardCrew.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOnboardCrewResponse>, I>>(base?: I): GetOnboardCrewResponse {
    return GetOnboardCrewResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOnboardCrewResponse>, I>>(object: I): GetOnboardCrewResponse {
    const message = createBaseGetOnboardCrewResponse();
    message.crews = object.crews?.map((e) => OnboardCrew.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetOnboardCrewByVesselImoRequest(): GetOnboardCrewByVesselImoRequest {
  return { vesselImo: "" };
}

export const GetOnboardCrewByVesselImoRequest: MessageFns<GetOnboardCrewByVesselImoRequest> = {
  encode(message: GetOnboardCrewByVesselImoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOnboardCrewByVesselImoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOnboardCrewByVesselImoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOnboardCrewByVesselImoRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
    };
  },

  toJSON(message: GetOnboardCrewByVesselImoRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOnboardCrewByVesselImoRequest>, I>>(
    base?: I,
  ): GetOnboardCrewByVesselImoRequest {
    return GetOnboardCrewByVesselImoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOnboardCrewByVesselImoRequest>, I>>(
    object: I,
  ): GetOnboardCrewByVesselImoRequest {
    const message = createBaseGetOnboardCrewByVesselImoRequest();
    message.vesselImo = object.vesselImo ?? "";
    return message;
  },
};

function createBaseAssignedVesselImoResponse(): AssignedVesselImoResponse {
  return { vesselImo: "" };
}

export const AssignedVesselImoResponse: MessageFns<AssignedVesselImoResponse> = {
  encode(message: AssignedVesselImoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignedVesselImoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignedVesselImoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignedVesselImoResponse {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
    };
  },

  toJSON(message: AssignedVesselImoResponse): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignedVesselImoResponse>, I>>(base?: I): AssignedVesselImoResponse {
    return AssignedVesselImoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignedVesselImoResponse>, I>>(object: I): AssignedVesselImoResponse {
    const message = createBaseAssignedVesselImoResponse();
    message.vesselImo = object.vesselImo ?? "";
    return message;
  },
};

function createBaseGetCrewsByVesselImoRequest(): GetCrewsByVesselImoRequest {
  return { vesselImo: "" };
}

export const GetCrewsByVesselImoRequest: MessageFns<GetCrewsByVesselImoRequest> = {
  encode(message: GetCrewsByVesselImoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCrewsByVesselImoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCrewsByVesselImoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCrewsByVesselImoRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
    };
  },

  toJSON(message: GetCrewsByVesselImoRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCrewsByVesselImoRequest>, I>>(base?: I): GetCrewsByVesselImoRequest {
    return GetCrewsByVesselImoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCrewsByVesselImoRequest>, I>>(object: I): GetCrewsByVesselImoRequest {
    const message = createBaseGetCrewsByVesselImoRequest();
    message.vesselImo = object.vesselImo ?? "";
    return message;
  },
};

function createBaseUpdateCrewChangePlanRequest(): UpdateCrewChangePlanRequest {
  return {
    crewId: "",
    crewChangeId: "",
    incomingFlight: undefined,
    onBoard: undefined,
    offBoard: undefined,
    outgoingFlight: undefined,
    expectedVersion: 0,
  };
}

export const UpdateCrewChangePlanRequest: MessageFns<UpdateCrewChangePlanRequest> = {
  encode(message: UpdateCrewChangePlanRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.crewId !== "") {
      writer.uint32(10).string(message.crewId);
    }
    if (message.crewChangeId !== "") {
      writer.uint32(18).string(message.crewChangeId);
    }
    if (message.incomingFlight !== undefined) {
      CrewChangeItem.encode(message.incomingFlight, writer.uint32(26).fork()).join();
    }
    if (message.onBoard !== undefined) {
      CrewChangeItem.encode(message.onBoard, writer.uint32(34).fork()).join();
    }
    if (message.offBoard !== undefined) {
      CrewChangeItem.encode(message.offBoard, writer.uint32(42).fork()).join();
    }
    if (message.outgoingFlight !== undefined) {
      CrewChangeItem.encode(message.outgoingFlight, writer.uint32(50).fork()).join();
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(56).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCrewChangePlanRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCrewChangePlanRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crewId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.crewChangeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.incomingFlight = CrewChangeItem.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.onBoard = CrewChangeItem.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.offBoard = CrewChangeItem.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.outgoingFlight = CrewChangeItem.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCrewChangePlanRequest {
    return {
      crewId: isSet(object.crewId)
        ? globalThis.String(object.crewId)
        : isSet(object.crew_id)
        ? globalThis.String(object.crew_id)
        : "",
      crewChangeId: isSet(object.crewChangeId)
        ? globalThis.String(object.crewChangeId)
        : isSet(object.crew_change_id)
        ? globalThis.String(object.crew_change_id)
        : "",
      incomingFlight: isSet(object.incomingFlight)
        ? CrewChangeItem.fromJSON(object.incomingFlight)
        : isSet(object.incoming_flight)
        ? CrewChangeItem.fromJSON(object.incoming_flight)
        : undefined,
      onBoard: isSet(object.onBoard)
        ? CrewChangeItem.fromJSON(object.onBoard)
        : isSet(object.on_board)
        ? CrewChangeItem.fromJSON(object.on_board)
        : undefined,
      offBoard: isSet(object.offBoard)
        ? CrewChangeItem.fromJSON(object.offBoard)
        : isSet(object.off_board)
        ? CrewChangeItem.fromJSON(object.off_board)
        : undefined,
      outgoingFlight: isSet(object.outgoingFlight)
        ? CrewChangeItem.fromJSON(object.outgoingFlight)
        : isSet(object.outgoing_flight)
        ? CrewChangeItem.fromJSON(object.outgoing_flight)
        : undefined,
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: UpdateCrewChangePlanRequest): unknown {
    const obj: any = {};
    if (message.crewId !== "") {
      obj.crewId = message.crewId;
    }
    if (message.crewChangeId !== "") {
      obj.crewChangeId = message.crewChangeId;
    }
    if (message.incomingFlight !== undefined) {
      obj.incomingFlight = CrewChangeItem.toJSON(message.incomingFlight);
    }
    if (message.onBoard !== undefined) {
      obj.onBoard = CrewChangeItem.toJSON(message.onBoard);
    }
    if (message.offBoard !== undefined) {
      obj.offBoard = CrewChangeItem.toJSON(message.offBoard);
    }
    if (message.outgoingFlight !== undefined) {
      obj.outgoingFlight = CrewChangeItem.toJSON(message.outgoingFlight);
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateCrewChangePlanRequest>, I>>(base?: I): UpdateCrewChangePlanRequest {
    return UpdateCrewChangePlanRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateCrewChangePlanRequest>, I>>(object: I): UpdateCrewChangePlanRequest {
    const message = createBaseUpdateCrewChangePlanRequest();
    message.crewId = object.crewId ?? "";
    message.crewChangeId = object.crewChangeId ?? "";
    message.incomingFlight = (object.incomingFlight !== undefined && object.incomingFlight !== null)
      ? CrewChangeItem.fromPartial(object.incomingFlight)
      : undefined;
    message.onBoard = (object.onBoard !== undefined && object.onBoard !== null)
      ? CrewChangeItem.fromPartial(object.onBoard)
      : undefined;
    message.offBoard = (object.offBoard !== undefined && object.offBoard !== null)
      ? CrewChangeItem.fromPartial(object.offBoard)
      : undefined;
    message.outgoingFlight = (object.outgoingFlight !== undefined && object.outgoingFlight !== null)
      ? CrewChangeItem.fromPartial(object.outgoingFlight)
      : undefined;
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

function createBaseUpdateCrewChangeContractRequest(): UpdateCrewChangeContractRequest {
  return { crewId: "", crewChangeId: "", contract: undefined, expectedVersion: 0 };
}

export const UpdateCrewChangeContractRequest: MessageFns<UpdateCrewChangeContractRequest> = {
  encode(message: UpdateCrewChangeContractRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.crewId !== "") {
      writer.uint32(10).string(message.crewId);
    }
    if (message.crewChangeId !== "") {
      writer.uint32(18).string(message.crewChangeId);
    }
    if (message.contract !== undefined) {
      CrewContract.encode(message.contract, writer.uint32(26).fork()).join();
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(32).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCrewChangeContractRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCrewChangeContractRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crewId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.crewChangeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.contract = CrewContract.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCrewChangeContractRequest {
    return {
      crewId: isSet(object.crewId)
        ? globalThis.String(object.crewId)
        : isSet(object.crew_id)
        ? globalThis.String(object.crew_id)
        : "",
      crewChangeId: isSet(object.crewChangeId)
        ? globalThis.String(object.crewChangeId)
        : isSet(object.crew_change_id)
        ? globalThis.String(object.crew_change_id)
        : "",
      contract: isSet(object.contract) ? CrewContract.fromJSON(object.contract) : undefined,
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: UpdateCrewChangeContractRequest): unknown {
    const obj: any = {};
    if (message.crewId !== "") {
      obj.crewId = message.crewId;
    }
    if (message.crewChangeId !== "") {
      obj.crewChangeId = message.crewChangeId;
    }
    if (message.contract !== undefined) {
      obj.contract = CrewContract.toJSON(message.contract);
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateCrewChangeContractRequest>, I>>(base?: I): UpdateCrewChangeContractRequest {
    return UpdateCrewChangeContractRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateCrewChangeContractRequest>, I>>(
    object: I,
  ): UpdateCrewChangeContractRequest {
    const message = createBaseUpdateCrewChangeContractRequest();
    message.crewId = object.crewId ?? "";
    message.crewChangeId = object.crewChangeId ?? "";
    message.contract = (object.contract !== undefined && object.contract !== null)
      ? CrewContract.fromPartial(object.contract)
      : undefined;
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

function createBaseUpdateCrewChangePlanResponse(): UpdateCrewChangePlanResponse {
  return {};
}

export const UpdateCrewChangePlanResponse: MessageFns<UpdateCrewChangePlanResponse> = {
  encode(_: UpdateCrewChangePlanResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCrewChangePlanResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCrewChangePlanResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateCrewChangePlanResponse {
    return {};
  },

  toJSON(_: UpdateCrewChangePlanResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateCrewChangePlanResponse>, I>>(base?: I): UpdateCrewChangePlanResponse {
    return UpdateCrewChangePlanResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateCrewChangePlanResponse>, I>>(_: I): UpdateCrewChangePlanResponse {
    const message = createBaseUpdateCrewChangePlanResponse();
    return message;
  },
};

function createBaseUpdateCrewChangeContractResponse(): UpdateCrewChangeContractResponse {
  return {};
}

export const UpdateCrewChangeContractResponse: MessageFns<UpdateCrewChangeContractResponse> = {
  encode(_: UpdateCrewChangeContractResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCrewChangeContractResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCrewChangeContractResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateCrewChangeContractResponse {
    return {};
  },

  toJSON(_: UpdateCrewChangeContractResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateCrewChangeContractResponse>, I>>(
    base?: I,
  ): UpdateCrewChangeContractResponse {
    return UpdateCrewChangeContractResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateCrewChangeContractResponse>, I>>(
    _: I,
  ): UpdateCrewChangeContractResponse {
    const message = createBaseUpdateCrewChangeContractResponse();
    return message;
  },
};

function createBaseAddCrewSsoUsernameRequest(): AddCrewSsoUsernameRequest {
  return { crewId: "", expectedVersion: 0 };
}

export const AddCrewSsoUsernameRequest: MessageFns<AddCrewSsoUsernameRequest> = {
  encode(message: AddCrewSsoUsernameRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.crewId !== "") {
      writer.uint32(10).string(message.crewId);
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(16).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddCrewSsoUsernameRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddCrewSsoUsernameRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crewId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddCrewSsoUsernameRequest {
    return {
      crewId: isSet(object.crewId)
        ? globalThis.String(object.crewId)
        : isSet(object.crew_id)
        ? globalThis.String(object.crew_id)
        : "",
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: AddCrewSsoUsernameRequest): unknown {
    const obj: any = {};
    if (message.crewId !== "") {
      obj.crewId = message.crewId;
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddCrewSsoUsernameRequest>, I>>(base?: I): AddCrewSsoUsernameRequest {
    return AddCrewSsoUsernameRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddCrewSsoUsernameRequest>, I>>(object: I): AddCrewSsoUsernameRequest {
    const message = createBaseAddCrewSsoUsernameRequest();
    message.crewId = object.crewId ?? "";
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

function createBaseAddCrewSsoUsernameResponse(): AddCrewSsoUsernameResponse {
  return { assignedSsoUsername: "", temporarySsoPassword: "" };
}

export const AddCrewSsoUsernameResponse: MessageFns<AddCrewSsoUsernameResponse> = {
  encode(message: AddCrewSsoUsernameResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assignedSsoUsername !== "") {
      writer.uint32(10).string(message.assignedSsoUsername);
    }
    if (message.temporarySsoPassword !== "") {
      writer.uint32(18).string(message.temporarySsoPassword);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddCrewSsoUsernameResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddCrewSsoUsernameResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignedSsoUsername = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.temporarySsoPassword = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddCrewSsoUsernameResponse {
    return {
      assignedSsoUsername: isSet(object.assignedSsoUsername)
        ? globalThis.String(object.assignedSsoUsername)
        : isSet(object.assigned_sso_username)
        ? globalThis.String(object.assigned_sso_username)
        : "",
      temporarySsoPassword: isSet(object.temporarySsoPassword)
        ? globalThis.String(object.temporarySsoPassword)
        : isSet(object.temporary_sso_password)
        ? globalThis.String(object.temporary_sso_password)
        : "",
    };
  },

  toJSON(message: AddCrewSsoUsernameResponse): unknown {
    const obj: any = {};
    if (message.assignedSsoUsername !== "") {
      obj.assignedSsoUsername = message.assignedSsoUsername;
    }
    if (message.temporarySsoPassword !== "") {
      obj.temporarySsoPassword = message.temporarySsoPassword;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddCrewSsoUsernameResponse>, I>>(base?: I): AddCrewSsoUsernameResponse {
    return AddCrewSsoUsernameResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddCrewSsoUsernameResponse>, I>>(object: I): AddCrewSsoUsernameResponse {
    const message = createBaseAddCrewSsoUsernameResponse();
    message.assignedSsoUsername = object.assignedSsoUsername ?? "";
    message.temporarySsoPassword = object.temporarySsoPassword ?? "";
    return message;
  },
};

function createBaseAddNewCrewChangeRequest(): AddNewCrewChangeRequest {
  return { crewId: "", rank: "", vesselImo: "", vesselName: "", voyageNumber: "", expectedVersion: 0 };
}

export const AddNewCrewChangeRequest: MessageFns<AddNewCrewChangeRequest> = {
  encode(message: AddNewCrewChangeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.crewId !== "") {
      writer.uint32(10).string(message.crewId);
    }
    if (message.rank !== "") {
      writer.uint32(18).string(message.rank);
    }
    if (message.vesselImo !== "") {
      writer.uint32(26).string(message.vesselImo);
    }
    if (message.vesselName !== "") {
      writer.uint32(34).string(message.vesselName);
    }
    if (message.voyageNumber !== "") {
      writer.uint32(42).string(message.voyageNumber);
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(48).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddNewCrewChangeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddNewCrewChangeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crewId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rank = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.voyageNumber = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddNewCrewChangeRequest {
    return {
      crewId: isSet(object.crewId)
        ? globalThis.String(object.crewId)
        : isSet(object.crew_id)
        ? globalThis.String(object.crew_id)
        : "",
      rank: isSet(object.rank) ? globalThis.String(object.rank) : "",
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : "",
      voyageNumber: isSet(object.voyageNumber)
        ? globalThis.String(object.voyageNumber)
        : isSet(object.voyage_number)
        ? globalThis.String(object.voyage_number)
        : "",
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: AddNewCrewChangeRequest): unknown {
    const obj: any = {};
    if (message.crewId !== "") {
      obj.crewId = message.crewId;
    }
    if (message.rank !== "") {
      obj.rank = message.rank;
    }
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.voyageNumber !== "") {
      obj.voyageNumber = message.voyageNumber;
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddNewCrewChangeRequest>, I>>(base?: I): AddNewCrewChangeRequest {
    return AddNewCrewChangeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddNewCrewChangeRequest>, I>>(object: I): AddNewCrewChangeRequest {
    const message = createBaseAddNewCrewChangeRequest();
    message.crewId = object.crewId ?? "";
    message.rank = object.rank ?? "";
    message.vesselImo = object.vesselImo ?? "";
    message.vesselName = object.vesselName ?? "";
    message.voyageNumber = object.voyageNumber ?? "";
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

function createBaseAddNewCrewChangeResponse(): AddNewCrewChangeResponse {
  return { crewId: "", crewChangeId: "" };
}

export const AddNewCrewChangeResponse: MessageFns<AddNewCrewChangeResponse> = {
  encode(message: AddNewCrewChangeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.crewId !== "") {
      writer.uint32(10).string(message.crewId);
    }
    if (message.crewChangeId !== "") {
      writer.uint32(18).string(message.crewChangeId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddNewCrewChangeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddNewCrewChangeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.crewId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.crewChangeId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddNewCrewChangeResponse {
    return {
      crewId: isSet(object.crewId)
        ? globalThis.String(object.crewId)
        : isSet(object.crew_id)
        ? globalThis.String(object.crew_id)
        : "",
      crewChangeId: isSet(object.crewChangeId)
        ? globalThis.String(object.crewChangeId)
        : isSet(object.crew_change_id)
        ? globalThis.String(object.crew_change_id)
        : "",
    };
  },

  toJSON(message: AddNewCrewChangeResponse): unknown {
    const obj: any = {};
    if (message.crewId !== "") {
      obj.crewId = message.crewId;
    }
    if (message.crewChangeId !== "") {
      obj.crewChangeId = message.crewChangeId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddNewCrewChangeResponse>, I>>(base?: I): AddNewCrewChangeResponse {
    return AddNewCrewChangeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddNewCrewChangeResponse>, I>>(object: I): AddNewCrewChangeResponse {
    const message = createBaseAddNewCrewChangeResponse();
    message.crewId = object.crewId ?? "";
    message.crewChangeId = object.crewChangeId ?? "";
    return message;
  },
};

export interface CrewService {
  addCrew(request: DeepPartial<Crew>, metadata?: grpc.Metadata): Promise<CrewResponse>;
  updateCrew(request: DeepPartial<UpdateCrewRequest>, metadata?: grpc.Metadata): Promise<CrewResponse>;
  updateAppraisal(request: DeepPartial<SubmitAppraisalRequest>, metadata?: grpc.Metadata): Promise<EmptyResponse>;
  addCrewSsoUsername(
    request: DeepPartial<AddCrewSsoUsernameRequest>,
    metadata?: grpc.Metadata,
  ): Promise<AddCrewSsoUsernameResponse>;
  addNewCrewChange(
    request: DeepPartial<AddNewCrewChangeRequest>,
    metadata?: grpc.Metadata,
  ): Promise<AddNewCrewChangeResponse>;
  updateCrewChangePlan(
    request: DeepPartial<UpdateCrewChangePlanRequest>,
    metadata?: grpc.Metadata,
  ): Promise<UpdateCrewChangePlanResponse>;
  updateCrewChangeContract(
    request: DeepPartial<UpdateCrewChangeContractRequest>,
    metadata?: grpc.Metadata,
  ): Promise<UpdateCrewChangeContractResponse>;
  getCrew(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetCrewResponse>;
  getCrewWithOnboardCrewChange(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOnboardCrewResponse>;
  getCrewWithOnboardCrewChangeByVesselImo(
    request: DeepPartial<GetOnboardCrewByVesselImoRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOnboardCrewResponse>;
  getAssignedVesselImoForCrew(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<AssignedVesselImoResponse>;
  getCrewById(request: DeepPartial<GetCrewByIdRequest>, metadata?: grpc.Metadata): Promise<CrewResponse>;
  getCrewByName(request: DeepPartial<Crew>, metadata?: grpc.Metadata): Promise<CrewResponse>;
  getCrewsByVesselImo(
    request: DeepPartial<GetCrewsByVesselImoRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetCrewResponse>;
}

export class CrewServiceClientImpl implements CrewService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.addCrew = this.addCrew.bind(this);
    this.updateCrew = this.updateCrew.bind(this);
    this.updateAppraisal = this.updateAppraisal.bind(this);
    this.addCrewSsoUsername = this.addCrewSsoUsername.bind(this);
    this.addNewCrewChange = this.addNewCrewChange.bind(this);
    this.updateCrewChangePlan = this.updateCrewChangePlan.bind(this);
    this.updateCrewChangeContract = this.updateCrewChangeContract.bind(this);
    this.getCrew = this.getCrew.bind(this);
    this.getCrewWithOnboardCrewChange = this.getCrewWithOnboardCrewChange.bind(this);
    this.getCrewWithOnboardCrewChangeByVesselImo = this.getCrewWithOnboardCrewChangeByVesselImo.bind(this);
    this.getAssignedVesselImoForCrew = this.getAssignedVesselImoForCrew.bind(this);
    this.getCrewById = this.getCrewById.bind(this);
    this.getCrewByName = this.getCrewByName.bind(this);
    this.getCrewsByVesselImo = this.getCrewsByVesselImo.bind(this);
  }

  addCrew(request: DeepPartial<Crew>, metadata?: grpc.Metadata): Promise<CrewResponse> {
    return this.rpc.unary(CrewServiceAddCrewDesc, Crew.fromPartial(request), metadata);
  }

  updateCrew(request: DeepPartial<UpdateCrewRequest>, metadata?: grpc.Metadata): Promise<CrewResponse> {
    return this.rpc.unary(CrewServiceUpdateCrewDesc, UpdateCrewRequest.fromPartial(request), metadata);
  }

  updateAppraisal(request: DeepPartial<SubmitAppraisalRequest>, metadata?: grpc.Metadata): Promise<EmptyResponse> {
    return this.rpc.unary(CrewServiceUpdateAppraisalDesc, SubmitAppraisalRequest.fromPartial(request), metadata);
  }

  addCrewSsoUsername(
    request: DeepPartial<AddCrewSsoUsernameRequest>,
    metadata?: grpc.Metadata,
  ): Promise<AddCrewSsoUsernameResponse> {
    return this.rpc.unary(CrewServiceAddCrewSsoUsernameDesc, AddCrewSsoUsernameRequest.fromPartial(request), metadata);
  }

  addNewCrewChange(
    request: DeepPartial<AddNewCrewChangeRequest>,
    metadata?: grpc.Metadata,
  ): Promise<AddNewCrewChangeResponse> {
    return this.rpc.unary(CrewServiceAddNewCrewChangeDesc, AddNewCrewChangeRequest.fromPartial(request), metadata);
  }

  updateCrewChangePlan(
    request: DeepPartial<UpdateCrewChangePlanRequest>,
    metadata?: grpc.Metadata,
  ): Promise<UpdateCrewChangePlanResponse> {
    return this.rpc.unary(
      CrewServiceUpdateCrewChangePlanDesc,
      UpdateCrewChangePlanRequest.fromPartial(request),
      metadata,
    );
  }

  updateCrewChangeContract(
    request: DeepPartial<UpdateCrewChangeContractRequest>,
    metadata?: grpc.Metadata,
  ): Promise<UpdateCrewChangeContractResponse> {
    return this.rpc.unary(
      CrewServiceUpdateCrewChangeContractDesc,
      UpdateCrewChangeContractRequest.fromPartial(request),
      metadata,
    );
  }

  getCrew(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetCrewResponse> {
    return this.rpc.unary(CrewServiceGetCrewDesc, EmptyRequest.fromPartial(request), metadata);
  }

  getCrewWithOnboardCrewChange(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOnboardCrewResponse> {
    return this.rpc.unary(CrewServiceGetCrewWithOnboardCrewChangeDesc, EmptyRequest.fromPartial(request), metadata);
  }

  getCrewWithOnboardCrewChangeByVesselImo(
    request: DeepPartial<GetOnboardCrewByVesselImoRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOnboardCrewResponse> {
    return this.rpc.unary(
      CrewServiceGetCrewWithOnboardCrewChangeByVesselImoDesc,
      GetOnboardCrewByVesselImoRequest.fromPartial(request),
      metadata,
    );
  }

  getAssignedVesselImoForCrew(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<AssignedVesselImoResponse> {
    return this.rpc.unary(CrewServiceGetAssignedVesselImoForCrewDesc, EmptyRequest.fromPartial(request), metadata);
  }

  getCrewById(request: DeepPartial<GetCrewByIdRequest>, metadata?: grpc.Metadata): Promise<CrewResponse> {
    return this.rpc.unary(CrewServiceGetCrewByIdDesc, GetCrewByIdRequest.fromPartial(request), metadata);
  }

  getCrewByName(request: DeepPartial<Crew>, metadata?: grpc.Metadata): Promise<CrewResponse> {
    return this.rpc.unary(CrewServiceGetCrewByNameDesc, Crew.fromPartial(request), metadata);
  }

  getCrewsByVesselImo(
    request: DeepPartial<GetCrewsByVesselImoRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetCrewResponse> {
    return this.rpc.unary(
      CrewServiceGetCrewsByVesselImoDesc,
      GetCrewsByVesselImoRequest.fromPartial(request),
      metadata,
    );
  }
}

export const CrewServiceDesc = { serviceName: "services.transportation.crew.CrewService" };

export const CrewServiceAddCrewDesc: UnaryMethodDefinitionish = {
  methodName: "AddCrew",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return Crew.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = CrewResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceUpdateCrewDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateCrew",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateCrewRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = CrewResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceUpdateAppraisalDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateAppraisal",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return SubmitAppraisalRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = EmptyResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceAddCrewSsoUsernameDesc: UnaryMethodDefinitionish = {
  methodName: "AddCrewSsoUsername",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return AddCrewSsoUsernameRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = AddCrewSsoUsernameResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceAddNewCrewChangeDesc: UnaryMethodDefinitionish = {
  methodName: "AddNewCrewChange",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return AddNewCrewChangeRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = AddNewCrewChangeResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceUpdateCrewChangePlanDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateCrewChangePlan",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateCrewChangePlanRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = UpdateCrewChangePlanResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceUpdateCrewChangeContractDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateCrewChangeContract",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateCrewChangeContractRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = UpdateCrewChangeContractResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceGetCrewDesc: UnaryMethodDefinitionish = {
  methodName: "GetCrew",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetCrewResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceGetCrewWithOnboardCrewChangeDesc: UnaryMethodDefinitionish = {
  methodName: "GetCrewWithOnboardCrewChange",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOnboardCrewResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceGetCrewWithOnboardCrewChangeByVesselImoDesc: UnaryMethodDefinitionish = {
  methodName: "GetCrewWithOnboardCrewChangeByVesselImo",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetOnboardCrewByVesselImoRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOnboardCrewResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceGetAssignedVesselImoForCrewDesc: UnaryMethodDefinitionish = {
  methodName: "GetAssignedVesselImoForCrew",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = AssignedVesselImoResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceGetCrewByIdDesc: UnaryMethodDefinitionish = {
  methodName: "GetCrewById",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetCrewByIdRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = CrewResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceGetCrewByNameDesc: UnaryMethodDefinitionish = {
  methodName: "GetCrewByName",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return Crew.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = CrewResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const CrewServiceGetCrewsByVesselImoDesc: UnaryMethodDefinitionish = {
  methodName: "GetCrewsByVesselImo",
  service: CrewServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetCrewsByVesselImoRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetCrewResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
